module.exports = __webpack_public_path__ + "img/icon18.1d367baf.png";